export default "__VITE_ASSET__b283cc5c__"